import { encode as base64_encode } from 'base-64';
import { postApi } from '../components/Utility'
import {
  action,
  makeObservable,
  observable,
} from 'mobx';
import config from '../config';
import utf8 from 'utf8';

class VehicleReturnAssetsStore {
  returnAsset = []

  total = 0
  loading = false
  rootStore

  constructor(rootStore) {
    makeObservable(this, {
      returnAsset: observable,
      total: observable,
      loading: observable,
      loadData: action,
      getReturnAssetData: action,
      addData: action,
      exportExcel: action,
      getAllocateVehicles: action

    });
    this.rootStore = rootStore;

  }

  async loadData({ companyId, offset, limit, searchField }) {
    let response
    this.loading = true;
    var postData = { "tokenId": "", "companyId": companyId, "offset": offset, "limit": limit, searchField: searchField }

    if (config.pythonReport === 1) {
      response = await postApi
        .getClient("")
        .get(config.NodeUrl + "/returnAssetsList/getreturnassetlist", {
          params: postData,
        });
    } else {
      const base64Input = await utf8.encode(JSON.stringify(postData));
      const base2 = JSON.stringify(base64_encode(base64Input));

      response = await postApi.getClient().post("index.php?c=allocatevehicle&a=getreturnAssetList", "postData=" + base2);
    }



    this.returnAsset = response?.data?.data?.returnAsset
    this.total = parseInt(response?.data?.data?.TotalCount)
    this.loading = false;

  }
  async addData(returnAsset) {
    let response
    if (config.pythonReport === 1) {
      response = await postApi
        .getClient("")
        .post(config.NodeUrl + "/returnAssetsList/return-asset", returnAsset);
    } else {
      var postData = returnAsset
      const base64Input = await base64_encode(JSON.stringify(postData));
      response = await postApi.getClient().post("index.php?c=allocatevehicle&a=returnasset", "postData=" + base64Input);
    }

    return response
  }

  async getReturnAssetData(Id, limit, offset) {
    let response
    const postData = { "rid": Id, limit: 1, offset: 0 }
    if (config.pythonReport === 1) {
      response = await postApi
        .getClient("")
        .get(config.NodeUrl + "/returnAssetsList/getreturnassetlist", {
          params: postData,
        });
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      response = await postApi.getClient().post("index.php?c=allocatevehicle&a=getreturnAssetList", "postData=" + base64Input);
    }

    return response?.data?.data?.returnAsset[0]
  }

  async deleteRecord({ Id }) {
    let response
    if (config.pythonReport === 1) {
      response = await postApi
        .getClient("")
        .delete(config.NodeUrl + `/assignVehicleList/deleteAssignVehicle/${Id}`);
    } else {
      var postData = { "tokenId": "", "Id": Id }
      const base64Input = await base64_encode(JSON.stringify(postData));
      response = await postApi.getClient().post("index.php?c=allocatevehicle&a=deleteAssignvehicle", "postData=" + base64Input);
    }

    return response;
  }

  //TO get asset dropdown
  async getAllocateVehicles({ companyId, asset }) {
    let response
    let postData
    if (config.pythonReport === 1) {
      if (asset === "returntoDriver") {
        postData = {
          tokenId: "",
          companyId: companyId,
          userid: null,
          isadmin: null,
          asset: asset,
        };

        response = await postApi
          .getClient("")
          .get(config.NodeUrl + "/assignVehicleList/getAllocateVehiclesData", {
            params: postData,
          });
        this.allocateVehicleAsset = response?.data?.data?.vehicles;
        return response?.data?.data?.vehicles;
      } else {
        postData = {
          tokenId: "",
          companyId: companyId,
          userid: null,
          isadmin: null,
          asset: asset,
        };

        response = await postApi
          .getClient("")
          .get(config.NodeUrl + "/assignVehicleList/getAllocateVehiclesData", {
            params: postData,
          });
        this.allocateVehicleAsset = response?.data?.data?.vehicles;
        return response?.data?.data?.vehicles;
      }
    } else {
      if (asset === "returntoDriver") {
        postData = { "tokenId": "", "companyId": companyId, "userid": null, "isadmin": null, "asset": asset };

        const base64Input = await base64_encode(JSON.stringify(postData));
        response = await postApi
          .getClient()
          .post("index.php?c=allocatevehicle&a=getallocateVehicles", "postData=" + base64Input);

        this.allocateVehicleAsset = response?.data?.data?.vehicles;
        return response?.data?.data?.vehicles;
      } else {
        postData = { "tokenId": "", "companyId": companyId, "userid": null, "isadmin": null, "asset": asset };

        const base64Input = await base64_encode(JSON.stringify(postData));
        response = await postApi
          .getClient()
          .post("index.php?c=allocatevehicle&a=getallocateVehicles", "postData=" + base64Input);

        this.allocateVehicleAsset = response?.data?.data?.vehicles;
        return response?.data?.data?.vehicles;
      }
    }


  }


  async exportExcel(getData) {
    if (config.pythonReport === 1) {
      try {
        var response = await postApi
          .getClient("")
          .post(
            config.NodeUrl + "/returnAssetsList/exportReturnAssets",
            getData,
            {
              responseType: "blob",
            }
          );
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "report.xlsx";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("Error downloading the file", error);
      }
    } else {
      window.location.href =
        config.baseURL +
        "index.php?c=vehicle&a=returnExportexcel&cid=" +
        getData.cid +
        "&searchField=" +
        getData.searchField +
        "&colList=" +
        getData.colList;
    }

  }
}

export default VehicleReturnAssetsStore;
  